import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_5 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_6 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_7 = { class: "sidebar-nav" }
const _hoisted_8 = { class: "nav-list" }
const _hoisted_9 = {
  key: 0,
  class: "nav-text"
}
const _hoisted_10 = {
  key: 0,
  class: "nav-tooltip"
}
const _hoisted_11 = { class: "sidebar-footer" }
const _hoisted_12 = { class: "user-info" }
const _hoisted_13 = { class: "user-avatar" }
const _hoisted_14 = {
  key: 0,
  class: "user-details"
}
const _hoisted_15 = { class: "user-name" }
const _hoisted_16 = { class: "main-content" }

import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

interface MenuItem {
  name: string
  title: string
  route: string
  description: string
  buttonText: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarNav',
  setup(__props) {

const route = useRoute()
const isCollapsed = ref(false)
const userName = ref('Admin User')

const menuItems = ref<MenuItem[]>([
  {
    name: 'Medical Schemes',
    title: 'Active Medical Schemes',
    route: '/health-insurances',
    description: 'This is the list of active medical schemes partners.',
    buttonText: 'MEDICAL SCHEMES',
    // icon: <IconName />
  },
  {
    name: 'Tariff Rates Management',
    title: 'Tariff Rates Management',
    route: '/schemes-tariff-rates',
    description: 'Manage Tariff Codes. Tariff codes are used to define the services and procedures that can be billed to clients. Amendment differs per business need.',
    buttonText: 'MANAGE TARIFF CODES AMENDMENT'
  },
  {
    name: 'Rollover Management',
    title: 'Tariff Code Rollover Staging',
    route: '/rollover-staging',
    description: 'Stage tariff code rollovers for the upcoming year. This allows you to prepare and review tariff code changes before they are applied.',
    buttonText: 'STAGE TARIFF CODES ROLLOVER'
  },
  {
    name: 'Reports',
    title: 'Reports',
    route: '/report-types',
    description: 'Report Types List',  
    buttonText: 'VIEW REPORTS'
  },
  // {
  //   name: 'AD-HOC',
  //   title: 'AD-HOC',
  //   route: '/programmes',
  //   description: 'Programme List',  
  //   buttonText: 'AD-HOC'
  // },
  // {
  //   name: 'Allowed Quantities',
  //   title: 'Tariff Code Allowed Quantities',
  //   route: '/tariff-codes',
  //   description: 'Manage allowed quantities for tariff codes. This is used to set the maximum number of units that can be billed for a tariff code.',
  //   buttonText: 'MANAGE ALLOWED QUANTITIES' 
  // },
])

const userInitials = computed(() => {
  return userName.value
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
})

const toggleSidebar = () => {
  isCollapsed.value = !isCollapsed.value
}

const isActive = (itemRoute: string) => {
  return route.path === itemRoute
}

const handleNavClick = (item: MenuItem) => {
  console.log('Navigating to:', item.name)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { 'sidebar-collapsed': isCollapsed.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!isCollapsed.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "CMS Admin"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: toggleSidebar,
          class: "toggle-btn",
          "aria-label": "Toggle sidebar"
        }, [
          (!isCollapsed.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("path", { d: "M15 18l-6-6 6-6" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("path", { d: "M9 18l6-6-6-6" }, null, -1)
              ]))]))
        ])
      ]),
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name,
              class: "nav-item"
            }, [
              _createVNode(_component_router_link, {
                to: item.route,
                class: _normalizeClass(["nav-link", { 'active': isActive(item.route) }]),
                onClick: ($event: any) => (handleNavClick(item))
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "nav-icon" }, [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "20",
                      height: "20",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "3",
                        width: "7",
                        height: "7"
                      }),
                      _createElementVNode("rect", {
                        x: "14",
                        y: "3",
                        width: "7",
                        height: "7"
                      }),
                      _createElementVNode("rect", {
                        x: "14",
                        y: "14",
                        width: "7",
                        height: "7"
                      }),
                      _createElementVNode("rect", {
                        x: "3",
                        y: "14",
                        width: "7",
                        height: "7"
                      })
                    ])
                  ], -1)),
                  (!isCollapsed.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.name), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class", "onClick"]),
              (isCollapsed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.name), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(userInitials.value), 1)
          ]),
          (!isCollapsed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(userName.value), 1),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "user-role" }, "Administrator", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("main", _hoisted_16, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})